import { getRequest } from "./request";
import { HomeData } from "../common/types/home";

export const getHomeData = async (): Promise<HomeData> => {
  return await getRequest<HomeData>(`templates/home`).then((res) => res.data);
};
